var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "accordion-with-title-description accordion",
      attrs: { role: "tablist" },
    },
    _vm._l(_vm.accordions, function (item, index) {
      return _c(
        "div",
        { key: index, staticClass: "accordion-item bg-white w-100 mb-1" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "b-toggle",
                  rawName: "v-b-toggle",
                  value: "collapse-" + index,
                  expression: "'collapse-' + index",
                },
              ],
              staticClass: "button p-3",
              attrs: { block: "", variant: "info" },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center px-4",
                },
                [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(item.title)),
                  ]),
                  _c("b-icon-chevron-right"),
                ],
                1
              ),
            ]
          ),
          _c(
            "b-collapse",
            {
              attrs: {
                id: "collapse-" + index,
                accordion: "my-accordion",
                role: "tabpanel",
              },
            },
            [
              _c("div", { staticClass: "container p-3" }, [
                _c("div", {
                  staticClass: "px-4",
                  domProps: { innerHTML: _vm._s(_vm.formattedText(item.text)) },
                }),
              ]),
            ]
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }